/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { CostMappingAlgorithm } from "~/generated/graphql";
import { options } from "~/views/settings/CostSplittingRulesPage/CostSplittingDefs";
import { OptionWithRadioButton } from "./OptionWithRadioButton";

type Props = {
  optionsNames: CostMappingAlgorithm[];
  algorithm?: CostMappingAlgorithm;
  savedSelections: boolean;
  onSettingsClick: () => void;
  onAlgorithmSelect: (optionName: CostMappingAlgorithm) => void;
};

export function CostSplitAlgorithmSelector({
  optionsNames,
  algorithm,
  savedSelections,
  onSettingsClick,
  onAlgorithmSelect,
}: Props) {
  const showSettingsButton = (optionName: CostMappingAlgorithm) => {
    return (
      savedSelections &&
      optionName === CostMappingAlgorithm.Manual &&
      algorithm === CostMappingAlgorithm.Manual
    );
  };

  return (
    <>
      {optionsNames.map((optionName) => {
        const option = options.get(optionName);
        return (
          <OptionWithRadioButton
            key={`option-${optionName}`}
            option={option}
            isChecked={optionName === algorithm}
            showSettingsButton={showSettingsButton(optionName)}
            onSettingsClick={onSettingsClick}
            onOptionChange={() => onAlgorithmSelect(optionName)}
          />
        );
      })}
    </>
  );
}
